import { tick } from 'svelte'

export async function renderTick() {
      const start = performance.now()
      const _promise: { start: number; end: number; delta: number } = await new Promise((r) =>
            requestAnimationFrame(() => {
                  const end = performance.now()
                  r({ start, end, delta: end - start })
            })
      )

      return _promise
}

export async function delay(ms: number) {
      return new Promise( r => {
            setTimeout(() => r(true), ms)
      })
}

export async function flipAnimation(element: HTMLElement, flip: () => void, options = {}) {
      const initRect = element.getBoundingClientRect()

      flip()
      await renderTick()

      //console.log(initRect)
      const nextRect = element.getBoundingClientRect()
      //console.log(nextRect)

      return element.animate(
            [
                  {
                        width: initRect.width + 'px',
                        height: initRect.height + 'px',
                  },
                  {
                        width: nextRect.width + 'px',
                        height: nextRect.height + 'px',
                  },
            ],
            { duration: 100, ...options }
      )
}

type AnimationOptions = { duration?: number; easing?: string; delay?: number; fill?: FillMode }

export class Flip {
      elements: HTMLElement[]
      options: AnimationOptions
      m: any[]

      constructor(elements: HTMLElement[], options: AnimationOptions = { duration: 1000, easing: 'ease-in-out', delay: 0 }) {
            this.elements = elements
            this.options = options
            this.m = this.measure()
            return this
      }

      async flip() {
            return this.flipElements()
      }

      async flipElements() {
            const start = this.m
            await tick()
            const end = this.measure()
            const promises = this.elements.map((_, i) => this.flipElement(i, start[i], end[i]))

            return await Promise.allSettled(promises)
      }

      async flipElement(index: number, start: any, end: any) {
            const element = this.elements[index]
            const animation = element.animate(
                  [
                        {
                              width: start.width + 'px',
                              height: start.height + 'px',
                              transform: `translate( ${start.x - end.x}px, ${start.y - end.y}px)`,
                        },
                        {
                              width: end.widht + 'px',
                              height: end.height + 'px',
                              transform: '',
                        },
                  ],
                  {
                        ...this.options,
                  }
            )

            return animation.finished
      }

      async animateElements(animations, options: any = {}) {
            const promises = animations.map((item, index) => {
                  const element = this.elements.find((e) => e.id == item.id)
                  if (!element) return
                  return this.animateElement(element, item.keyframes, options)
            })

            await Promise.allSettled(promises)
      }

      async animateElement(element: HTMLElement, keyframes: any, options: any) {
            const animation = element.animate([...keyframes], {
                  ...this.options,
                  ...options,
            })

            return animation
      }

      measure() {
            this.m = this.elements.map((e) => e.getBoundingClientRect())
            return this.m
      }
}



export async function flipOpacity({element, flipFn, options = {} }: {element: HTMLElement, flipFn: Function, options?: KeyframeAnimationOptions }) {
      if (!element) return
      element.getAnimations().map((a) => a.pause())

      const start_opacity = getComputedStyle(element).opacity
      const start_display = getComputedStyle(element).display

      element.getAnimations().map((a) => a.cancel())

      const _call = flipFn()
      let res = _call
      if( res instanceof Promise ) res = await _call

      await tick()

      const end_opacity = getComputedStyle(element).opacity
      const end_display = getComputedStyle(element).display

      element.animate(
            [
                  { opacity: start_opacity, display: start_display },
                  { opacity: end_opacity, display: end_display },
            ],
            {
                  duration: 400,
                  fill: 'backwards',
                  ...options
            }
      )
}